import DeleteProgramButton from '@/components/program/DeleteProgramButton';
import { Blockquote } from '@/components/ui/blockquote';
import { Card, HStack, Mark, Text, VStack } from '@chakra-ui/react';
import type { Program } from '@fluenceur/types';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { WarningTriangle } from 'iconoir-react';

interface ProgramDangerZoneProps {
  program: Program;
}

const ProgramDangerZone: React.FC<ProgramDangerZoneProps> = ({ program }) => {
  const { t } = useTranslation();

  return (
    <Card.Root w="full" p={8} borderColor="red.200" borderWidth="2px" bg="red.25">
      <Card.Header p={0}>
        <HStack gap={3} color="red.600">
          <WarningTriangle width={24} height={24} />
          <Card.Title fontSize="2xl" color="red.600">
            {t('programs.programOverview.dangerZone.title')}
          </Card.Title>
        </HStack>
      </Card.Header>

      <Card.Body p={0} mt={6}>
        <VStack align="stretch" gap={4}>
          <Blockquote variant="solid" colorPalette="red" bg="red.50" p={4}>
            <Text fontWeight="semibold" color="red.fg" mb={2}>
              {t('programs.programOverview.dangerZone.deleteTitle')}
            </Text>
            <Text fontSize="sm" color="red.fg">
              {t('programs.programOverview.dangerZone.deleteDesc')}{' '}
              <Mark color="red.600" variant="subtle">
                {t('programs.programOverview.dangerZone.deleteDescHighlight')}
              </Mark>{' '}
              {t('programs.programOverview.dangerZone.deleteDescContinued')}
            </Text>
          </Blockquote>

          <HStack justify="flex-end">
            <DeleteProgramButton programId={program.id} programName={program.name} />
          </HStack>
        </VStack>
      </Card.Body>
    </Card.Root>
  );
};

export default ProgramDangerZone;
